/**
* When money is deposited, add it to the user's credit or just to
*             the machine for increasing the change.
*/
export enum DepositMode { 
	/** Default mode: Add deposited money to the user's credit. */
	Credit = "Credit", 
	/**
	* Manual filling of change money, e.g. to increase the number of coins
	*             in the tubes.
	*/
	Change = "Change"
}
